<div (click)="open()"
    #notificationWrapper
    [ngClass]="{'deleted': deleted}"
    class="rounded-2 background-danger border-3 border-bottom pointer notification-wrapper">
    <div class="d-flex justify-content-between">
        <div class="d-flex flex-column gap-2 text-white p-3">
            <div class="align-items-baseline d-flex flex-row gap-2">
                <i class="fa-solid fa-triangle-exclamation color-warning fa-2x"></i>
                <div class="">{{ timestamp }}</div>
            </div>
            <div class="fs-5 fw-bold">{{ text }}</div>
        </div>
        <div class="dismiss-button" (click)="delete($event, notification!)">
            <i class="fa-solid fa-trash-can"></i>
        </div>
    </div>
</div>
